import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { MessageBox } from 'shared/components/dialogs/message-box';
import { Box, Typography } from '@mui/material';
import { Circle, KeyPad, RoundButton } from 'console/app-settings/pin-dialogs/utils';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { close_ask_pin_dialog, set_pin } from 'console/app-settings/redux/actions';
export function AskPinDialog(props) {
    const [input, setInput] = useState('');
    const [invalid, setInvalid] = useState(false);
    useEffect(() => {
        if (props.open) {
            setInput('');
            setInvalid(false);
        }
    }, [props.open, setInvalid, setInput]);
    const on_digit = useCallback((digit) => {
        const new_input = input + digit;
        setInput(new_input);
    }, [input, setInput]);
    const on_release = useCallback(() => {
        if (props.pin != null && input.length === props.pin.length) {
            if (input === props.pin) {
                props.onSuccess();
            }
            else {
                setInput('');
                setInvalid(true);
            }
        }
    }, [input, props.pin, props.onSuccess, setInput, setInvalid]);
    const on_clear = useCallback(() => {
        setInput('');
        setInvalid(false);
    }, [setInput, setInvalid]);
    let isError = false;
    let title;
    const titleStyle = { textAlign: 'center' };
    if (invalid) {
        titleStyle.color = '#c4443b';
        title = 'Неверный код';
        isError = true;
    }
    else
        title = 'Введите пин-код';
    return (_jsxs(MessageBox, { open: props.open, title: title, onClose: props.onCancel, style: { zIndex: 10000 }, children: [isError && (_jsx(Typography, { variant: "subtitle1", color: "error", children: title })), _jsx(Box, { sx: {
                    fontSize: '48px',
                    display: 'flex',
                    flexFlow: 'row nowrap',
                    justifyContent: 'center',
                    height: '62px',
                    lineHeight: 1,
                    '& > div': {
                        flexBasis: '38px',
                        flexShrink: 1,
                        textAlign: 'center',
                    },
                }, children: props.pin != null &&
                    new Array(props.pin.length)
                        .fill(0)
                        .map((_, i) => _jsx(Circle, { filled: i < input.length }, i)) }), _jsx(KeyPad, { onDigit: on_digit, onClear: on_clear, onRelease: on_release, cornerButton: props.onForgot != null ? (_jsx(RoundButton, { onRelease: props.onForgot, children: _jsxs("span", { className: "forgot", children: ["\u0437\u0430\u0431\u044B\u043B\u0438", _jsx("br", {}), "\u043A\u043E\u0434?"] }) })) : undefined })] }));
}
export function ReduxAskPinDialog() {
    const opened = useAppSelector((state) => state.app_settings.opened_ask_pin_dialog);
    const pin = useAppSelector((state) => state.app_settings.settings?.pin);
    const closeAskingPinDialog = useAction(close_ask_pin_dialog);
    const onSetPin = useAction(set_pin);
    const on_ask_pin_success = useCallback(() => {
        closeAskingPinDialog();
        onSetPin(null);
    }, [closeAskingPinDialog, onSetPin]);
    return (_jsx(AskPinDialog, { open: opened, pin: pin, onSuccess: on_ask_pin_success, onCancel: closeAskingPinDialog }));
}
